module.exports = __webpack_public_path__ + "images/mobile/img-empty-todo-done-4d8e8a60b79f748112e2de95488b0b73.png";